/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import backArrowIcon from "../../../../assets/icons/back-arrow.svg";
import searchIcon from "../../../../assets/icons/search.svg";
import closeIcon from "../../../../assets/icons/social/close.svg";
import { SearchBox } from "../../basic/search-box";
import { SvgHandler } from "../../svg-handler/svg-handler";
import "./header-search.m.css";

const DrawForm = ({ children }) => {
  return (
    <div>
      <div styleName="internal-search-wrapper">
        <label htmlFor="searchForm" key="1">
          {children}
        </label>
      </div>
    </div>
  );
};

DrawForm.propTypes = {
  children: PropTypes.element
};

const HeaderSearch = props => {
  const { dataTestId, toggleSearchForm, closeAll, hideSearchForm, header = {}, headerType = "" } = props;
  const isSearchFormVisible = header.isSearchFormVisible;
  const searchBoxRef = useRef(null);
  const [showClearButton, setShowClearButton] = useState(false);

  return (
    <div styleName={`search-wrapper ${headerType}`}>
      <div
        data-test-id={dataTestId}
        styleName={`search-icon ${isSearchFormVisible ? "highlight-search" : ""}`}
        onClick={toggleSearchForm}
      >
        <SvgHandler
          xlinkHref={searchIcon}
          clazzName="search"
          width="24"
          height="24"
          svgWrapperClazzName="svg-wrapper"
        />
      </div>
      {!isSearchFormVisible ? null : (
        <div>
          <button styleName="back-button" onClick={hideSearchForm}>
            <SvgHandler width="24" height="24" xlinkHref={backArrowIcon} />
          </button>
          <SearchBox
            ref={searchBoxRef}
            styleName={`search-form search-form--visible`}
            inputId="searchForm"
            inputClassName="search-form-input"
            placeholder="Search Here"
            onSubmitHandler={closeAll}
            onEscape={hideSearchForm}
            template={DrawForm}
            onChange={value => {
              if (showClearButton && value === "") {
                setShowClearButton(false);
              }
              if (!showClearButton && value !== "") {
                setShowClearButton(true);
              }
            }}
          />
          {showClearButton && (
            <button
              styleName="search-clear-btn"
              onClick={() => {
                searchBoxRef.current && searchBoxRef.current.clearText();
              }}
            >
              <SvgHandler xlinkHref={closeIcon} clazzName="close-icon" width="24" height="24" />
            </button>
          )}
        </div>
      )}
    </div>
  );
};
HeaderSearch.propTypes = {
  header: PropTypes.object,
  hideSearchForm: PropTypes.func,
  toggleSearchForm: PropTypes.func,
  closeAll: PropTypes.func,
  isSearchFormVisible: PropTypes.bool,
  dataTestId: PropTypes.string,
  headerType: PropTypes.string
};
export { HeaderSearch };
